import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true
})

export function apiResponse(res: any, customTitle?: string) {
  const title = customTitle || res?.msg || 'Operación exitosa'
  Toast.fire({ title, icon: 'success' })
  return res
}

export function apiInfo(resOrMsg: any, customTitle?: string) {
  const title = customTitle || (typeof resOrMsg === 'string' ? resOrMsg : resOrMsg?.msg) || 'Aviso'
  Toast.fire({ title, icon: 'info' })
  return resOrMsg
}

export function apiLog(_res?: any, _customTitle?: string) {
  console.log(_customTitle || 'LOG:', _res)
  return _res
}

export function apiError(err: any, customTitle?: string) {
  const title = customTitle || err?.error?.message || err?.message || 'Error de conexión'



  Toast.fire({ title, icon: 'error', timer: 6000 })
  return err
}
